document.addEventListener('DOMContentLoaded', function() {
  var loadMoreButton = document.getElementById('load-more');
  if (!loadMoreButton) return;

  loadMoreButton.addEventListener('click', function() {
    loadMoreButton.style.display = 'none'; // Hide button once clicked
    loadProducts(loadMoreButton.getAttribute('data-url'));
  });
});

function loadProducts(url) {
  fetch(url)
    .then(response => response.text())
    .then(data => {
      var parser = new DOMParser();
      var doc = parser.parseFromString(data, 'text/html');
      var products = doc.getElementById('product-grid');
      document.getElementById('product-grid').innerHTML += products.innerHTML;
      var newUrl = doc.getElementById('load-more')?.getAttribute('data-url');
      if (newUrl) {
        loadProducts(newUrl); // Load next batch of products
      }
    });
}
